import React, { lazy, Suspense } from 'react';

const LazyTechSupportDetail = lazy(() => import('./TechSupportDetail'));

const TechSupportDetail = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyTechSupportDetail {...props} />
  </Suspense>
);

export default TechSupportDetail;
